import {
	useSalesChannelCategoryCreateMutation,
	useSalesChannelCategoryDeleteMutation,
	useSalesChannelCategoryUpdateMutation,
} from "@/generated/graphql";

export interface CategoryCreateInput {
	salesChannelCategoryGroupID: string;
	salesChannelCategoryName: string;
	displayOrder: number;
	isActive: boolean;
	isInMenu: boolean;
}

export interface CategoryUpdateInput extends CategoryCreateInput {
	salesChannelCategoryID: string;
}

export const useSalesChannelCategoryMutations = () => {
	const [, create] = useSalesChannelCategoryCreateMutation();
	const [, update] = useSalesChannelCategoryUpdateMutation();
	const [, del] = useSalesChannelCategoryDeleteMutation();

	return {
		create: (input: CategoryCreateInput) => create({ input }),
		update: (input: CategoryUpdateInput) => update({ input }),
		remove: (id: string) => del({ id }),
	};
};
